module.exports = __webpack_public_path__ + "static/office-worker-c899b2d4f68a8534f73a0fd9a0ed88a1.svg";